import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manuales',
  templateUrl: './manuales.component.html',
  styleUrls: ['./manuales.component.css']
})
export class ManualesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
